import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleValidationSchema } from '@/features/clientRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateClientRoleProps {
  permissions: { permission_id: string }[]
  onSuccess: () => void
  onError: (error: any) => void
}

export const useCreateClientRole = ({ permissions, onSuccess, onError }: UseCreateClientRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createClientRole'],
    mutationFn: async (form: RoleValidationSchema) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        permission_roles_attributes: permissions,
        level: Number(form.level) || 0,
        permit_reset_client_user_password_by_others: form.permit_reset_client_user_password_by_others,
      }

      return privateAxios.post('/client/roles', { ...payload })
    },
    onSuccess,
    onError,
  })
}
